module.exports = __webpack_public_path__ + "static/livestorm-thumbnail1-af8c0e1c79a9759ac7fc2ce52fd1ece2.png";